import { createSelector } from 'reselect';

import { applicantTypeSelector } from '../../store/applicant/selectors';
import {
  appealErrorSelector,
  appealLoadingSelector,
  appealFoundSelector,
  appealIsApplicantAuthorSelector,
  appealServiceNumberSelector,
  appealCanBeCanceledSelector
} from '../../store/appealFind/selectors';

const appealExistsSelector = createSelector(
  applicantTypeSelector,
  appealErrorSelector,
  appealLoadingSelector,
  appealFoundSelector,
  appealIsApplicantAuthorSelector,
  appealServiceNumberSelector,
  appealCanBeCanceledSelector,
  (
    applicantType,
    error,
    loading,
    found,
    isAuthor,
    serviceNumber,
    canBeCanceled
  ) => {
    return {
      applicantType,
      error,
      loading,
      found,
      isAuthor,
      serviceNumber,
      canBeCanceled
    };
  }
);

export default appealExistsSelector;
